// removed by extract-text-webpack-plugin
module.exports = {"clickarea":"Summary-hashed__clickarea__3SMJy","clickarea__content":"Summary-hashed__clickarea__content__1F4zv","clickarea__header":"Summary-hashed__clickarea__header__21OpQ","clickarea__chevron":"Summary-hashed__clickarea__chevron__iZmet","memo":"Summary-hashed__memo__3WZ6j"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/Summary-hashed.scss
// module id = 1236
// module chunks = 0